import { ServiceBase } from "./service-base";
import { MskScore } from "../../models/interfaces/msk-score";

export interface PartialMskSummaryResponse {
    beatOneMskScoreBenchmark: string;
    beatTwoMskRiskSummary: string;
    beatThreePainSummary: string;
    beatFourFocusAreasSummary: string;
    beatFiveClosingInsight: string;
}

const baseEndpoint = `/ai`;
const riskSummaryEndpoint = `${baseEndpoint}/risk-summary`;
const mskSummaryEndpoint = `${baseEndpoint}/msk-summary`;
const partialMskSummaryEndpoint = `${baseEndpoint}/partial-msk-summary`;

const AiService = {
    async riskSummary(input: string): Promise<string> {
        const result = await ServiceBase.post<string, { input: string }>(riskSummaryEndpoint)(
            { input }
        );
        return result;
    },

    async mskSummary(mskScore: MskScore): Promise<string> {
        const result = await ServiceBase.post<string, { mskScore: MskScore }>(mskSummaryEndpoint)(
            { mskScore }
        );
        return result;
    },

    async partialMskSummary(partialMskScore: any): Promise<PartialMskSummaryResponse> {
        const result = await ServiceBase.post<PartialMskSummaryResponse, { partialMskScore: any }>(partialMskSummaryEndpoint)(
            { partialMskScore }
        );
        return result;
    },
};

export { AiService };